/**
 * Convierte links "para compartir" (Google Drive, Dropbox, GitHub) en links directos de imagen
 * y separa varias fotos aunque vengan con coma, salto de línea o "|".
 */
export function toDirectImageUrl(raw: string): string {
  const url = raw.trim().replace(/^["'<]+|["'>]+$/g, '');
  if (!url) return '';

  // Google Drive: /file/d/ID/..., open?id=ID, uc?id=ID, thumbnail?id=ID
  const driveId =
    url.match(/drive\.google\.com\/file\/d\/([\w-]{10,})/)?.[1] ??
    url.match(/drive\.google\.com\/(?:open|uc|thumbnail)\?(?:.*&)?id=([\w-]{10,})/)?.[1] ??
    url.match(/docs\.google\.com\/uc\?(?:.*&)?id=([\w-]{10,})/)?.[1];
  if (driveId) return `https://lh3.googleusercontent.com/d/${driveId}=w1600`;

  // Dropbox: forzar descarga directa
  if (/dropbox\.com/.test(url)) {
    try {
      const u = new URL(url);
      u.searchParams.delete('dl');
      u.searchParams.set('raw', '1');
      return u.toString();
    } catch {
      return url;
    }
  }

  // GitHub: blob -> raw
  const gh = url.match(/^https?:\/\/github\.com\/([^/]+\/[^/]+)\/blob\/(.+)$/);
  if (gh) return `https://raw.githubusercontent.com/${gh[1]}/${gh[2]}`;

  if (url.startsWith('//')) return `https:${url}`;
  if (/^www\./.test(url)) return `https://${url}`;
  return url;
}

export function normalizeImageList(list: string[]): string[] {
  return list
    .flatMap((item) => String(item ?? '').split(/[\n|,;]+|\s+(?=https?:\/\/)/))
    .map(toDirectImageUrl)
    .filter((u) => /^(https?:|data:image\/)/.test(u));
}
